import { ADD_SETTINGS } from "../constants/settingsConstants";

export const addSettings = settings => ({
  type: ADD_SETTINGS,
  payload: settings
});
